import { useState, useEffect } from "react"

import CoachInfo from "@/app/settings/club/coaches/CoachInfo"
import CoachTable from "@/app/settings/club/coaches/CoachTable"
import LeaveCoachDialog from "@/app/settings/club/coaches/LeaveCoachDialog"
import Search from "@/components/form/search/Search"
import { useTeamCoachListQuery } from "@/hooks/api/useCoachQuery"

export default function TabCoach() {
  const [selectedId, setSelectedId] = useState(0)
  const [open, setOpen] = useState(false)
  const [keyword, setKeyword] = useState("")

  const { data } = useTeamCoachListQuery()

  useEffect(() => {
    if (data && data.length > 0) {
      setSelectedId(data[0].idfCoach)
    }
  }, [data])

  const openDialog = () => {
    setOpen(true)
  }

  return (
    <div className="Coach-Page">
      <div className="search-and-button">
        <Search onChange={setKeyword} />
      </div>
      <div className="Coach-Table-Info">
        <CoachTable selectedId={selectedId} setSelectedId={setSelectedId} searchKeyword={keyword} />
        <CoachInfo selectedId={selectedId} openDialog={openDialog} />
      </div>
      <LeaveCoachDialog
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        open={open}
        onClose={() => setOpen(false)}
      />
    </div>
  )
}
